import { render, staticRenderFns } from "./SinglePhotos.vue?vue&type=template&id=ff38ce0a&lang=pug&"
import script from "./SinglePhotos.vue?vue&type=script&lang=js&"
export * from "./SinglePhotos.vue?vue&type=script&lang=js&"
import style0 from "./SinglePhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports